export const BASE_URL = "https://siwesi-dev.dsdajakarta.id/"